import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import PreferenceService from "../services/preference.service";


import { rejectedList } from "./listState";
const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0,
};






export const listPreference = createAsyncThunk(
  "Preference/get_list",
  async ({ search }, thunkAPI) => {
    try {
      const data = await PreferenceService.listPreference(search);
      return { Preference: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getPreference = createAsyncThunk(
  "Preference/get",

  async ({ id }, thunkAPI) => {
    try {
      const data = await PreferenceService.getPreference(id);
      return { Preference: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);



export const getPreferenceFilterValues = createAsyncThunk(
  "Preference/get_filter_values_list",
  async ({ search }, thunkAPI) => {
    try {
      const data = await PreferenceService.getPreferenceFilterValues(search);
      return { filter_values: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const getPreferenceUi = createAsyncThunk(
  "Preference/get_ui",
  async ({ }, thunkAPI) => {
    try {
      const data = await PreferenceService.getPreferenceUi();
      return { ui: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const updatePreference = createAsyncThunk(
  "Preference/update",
  async ({ preference }, thunkAPI) => {
    try {
      const data = await PreferenceService.updatePreference(preference);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updatePreferenceByUser = createAsyncThunk(
  "Preference/update_by_user",
  async ({ preference }, thunkAPI) => {
    try {
      const data = await PreferenceService.updatePreferenceByUser(preference);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getColumnPreference = createAsyncThunk(
  "Preference/get_column_preference",
  async ({ name }, thunkAPI) => {
    try {
      const data = await PreferenceService.getPreferenceByName(name);
      return { data };
    } catch (error) {
      // Non-fatal: column preference may not exist yet
      return thunkAPI.rejectWithValue();
    }
  }
);


const initialState = {
  data: list,
  loading: false,
  filter_values: [],
  Ui: [],
  columnPreference: null,
  columnPreferences: {},
}

const PreferenceSlice = createSlice({
  name: "Preference",
  initialState,

  extraReducers: {

    [updatePreference.fulfilled]: (state, action) => {

      const updatedPreference = state.data.list.map((Preference) => {
        if (Preference.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return Preference;
        }
      });
      state.data.list = updatedPreference;
    },

    

    [getPreferenceUi.pending]: (state, action) => {
      state.loading = true;
    },
    [getPreferenceUi.fulfilled]: (state, action) => {
      state.Ui = action.payload.ui;
      state.loading = false;
    },
    [getPreferenceUi.rejected]: (state, action) => {
      state.Ui = null;
      state.loading = false;
    },

    [getPreferenceFilterValues.pending]: (state, action) => {
      state.loading = true;
    },
    [getPreferenceFilterValues.fulfilled]: (state, action) => {
     

      state.filter_values = action.payload.filter_values;
      state.loading = false;
    },
    [getPreferenceFilterValues.rejected]: (state, action) => {
      state.filter_values = rejectedList(state.filter_values, action);
      state.loading = false;
    },





    [listPreference.pending]: (state, action) => {
      state.loading = true;
    },
    [listPreference.fulfilled]: (state, action) => {

      //debugger

      state.data = action.payload.Preference;
      state.loading = false;
    },
    [listPreference.rejected]: (state, action) => {
      state.data = rejectedList(state.data, action);
      state.loading = false;
    },



    [getPreference.pending]: (state, action) => {
      state.loading = true;
    },
    [getPreference.fulfilled]: (state, action) => {

     

      const newPayload = action.payload.Preference;

      const existingIndex = state.data.list.findIndex(
        payload => payload.id === newPayload.id
      );
    
      if (existingIndex >= 0) {
        // The payload already exists, replace it
        state.data.list[existingIndex] = newPayload;
      } else {
        // The payload doesn't exist, add it
        state.data.list.push(newPayload);
      }


      state.loading = false;
    },
    [getPreference.rejected]: (state, action) => {
      state.loading = false;
    },

    [getColumnPreference.fulfilled]: (state, action) => {
      const prefName = action.meta?.arg?.name;
      const list = action.payload?.data?.list;
      let parsed = null;
      if (list && list.length > 0) {
        const raw = list[0].preferenceValue || list[0].preference_value;
        try {
          parsed = JSON.parse(raw);
        } catch {
          parsed = null;
        }
      }
      // Legacy single field (backward compat)
      state.columnPreference = parsed;
      // Keyed storage for multi-table support
      if (prefName) {
        state.columnPreferences[prefName] = parsed;
      }
    },
    [getColumnPreference.rejected]: (state, action) => {
      const prefName = action.meta?.arg?.name;
      state.columnPreference = null;
      if (prefName) {
        state.columnPreferences[prefName] = null;
      }
    },
    [updatePreferenceByUser.rejected]: (state) => {
      // silent fail — preference save is best-effort
    },

  },
});

const { reducer } = PreferenceSlice;
export default reducer;
